<template>
  <BaseButtonIcon
    type="button"
    size="small"
    theme="blue"
    outline
    :title="openPolicyLabel"
    :aria-label="openPolicyLabel"
    @click="openPolicy"
  >
    <NewTabIcon />
  </BaseButtonIcon>
</template>

<script setup lang="ts">
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import NewTabIcon from '@/components/icon_components/NewTabIcon.vue'
import { openRouteInTab } from '@/helpers/routeInTab'
import { useI18n } from '@/hooks/useI18N'
import { ROUTE_POLICY_EDIT } from '@/router/routes/routeNames'
import { computed } from 'vue'

const props = defineProps<{
  policyId: string | number
}>()

const i18n = useI18n()

const openPolicyLabel = computed(() =>
  i18n.t('policy.OPEN_POLICY_IN_NEW_TAB').toString()
)

// New tab on purpose: the policy selectors sit in forms holding unsaved state.
const openPolicy = () => {
  openRouteInTab(ROUTE_POLICY_EDIT, { policyId: String(props.policyId) })
}
</script>
